var ErrorExpectationType;
(function (ErrorExpectationType) {
    ErrorExpectationType["Expected"] = "EXPECTED";
    ErrorExpectationType["Unexpected"] = "UNEXPECTED";
})(ErrorExpectationType || (ErrorExpectationType = {}));
export default ErrorExpectationType;
